import { faArrowLeft, faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { CarouselRef } from 'antd/lib/carousel';
import React from 'react';
import { isFirst, isLast, classes } from '../../../lib';
import { Button } from '../../Button';
import { Carousel } from '../../Carousel';
import { FontAwesomeIcon } from '../../FontAwesomeIcon';
import Styles from './TestimonialSection.module.less';

export type TestimonialSectionProps = {
    children: React.ReactNode[];
};

export const TestimonialSection = (p: TestimonialSectionProps): JSX.Element => {
    const carousel = React.createRef<CarouselRef>();
    const [currentlyShown, setCurrentlyShown] = React.useState(0);
    return (
        <div className={classes('vertical stretch-top g12', Styles.container)}>
            <div
                className={classes(
                    'horizontal right-top self-center mt-px16 g12',
                    Styles.buttons
                )}>
                <Button
                    aria-label="Item anterior"
                    type="text"
                    size="large"
                    icon={<FontAwesomeIcon icon={faArrowLeft} />}
                    disabled={isFirst(currentlyShown)}
                    onClick={() => {
                        carousel?.current?.prev();
                    }}
                />
                <Button
                    aria-label="Próximo item"
                    type="text"
                    size="large"
                    icon={<FontAwesomeIcon icon={faArrowRight} />}
                    disabled={isLast(currentlyShown, p.children.length)}
                    onClick={() => {
                        carousel?.current?.next();
                    }}
                />
            </div>
            <Carousel
                accessibility
                className={Styles.carousel}
                myRef={carousel}
                afterChange={setCurrentlyShown}
                dots={false}
                arrows={false}>
                {React.Children.map(p.children, (child, index) => (
                    <div key={index} className={classes(Styles.child)}>
                        {child}
                    </div>
                ))}
            </Carousel>
        </div>
    );
};
